import styled from '@emotion/styled';
import {
  AdAnalyticsFilter,
  AdAnalyticsPlacementTypes,
  AdAnalyticsVideo,
  AdAnalyticsVideoFilter,
  AdAnalyticsVideoSort,
} from '@kaizenplatform/hugot-entity';
import { Paper, Tab, Tabs, Typography } from '@material-ui/core';
import { List } from 'immutable';
import { createElement, FC, Fragment, useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import CreativePerformanceBrowsingAd from '../../../entity/CreativePerformanceBrowsingAd';
import CreativePerformanceBrowsingCampaign from '../../../entity/CreativePerformanceBrowsingCampaign';
import CreativePerformanceBrowsingCreative from '../../../entity/CreativePerformanceBrowsingCreative';
import Spinner from '../../component/compound/Spinner';
import LoadMoreButton from '../../component/primitive/LoadMoreButton';
import { SCREEN_LARGE } from '../../constant/pageWidth';
import { SPACING_HUGE, SPACING_LARGE, SPACING_UNIT } from '../../constant/spacing';
// import { flexibleLayoutContainer } from '../../styleUtility/flexibleLayout';
import { gridLayoutContainer } from '../../styleUtility/gridLayout';
// import Filters from './AdAnalyticsListFilters';
import AnalyticsItemTable from './AnalyticsItemTable';

type Props = {
  className?: string;
  loading: boolean;
  appendLoading: boolean;
  creatives: List<CreativePerformanceBrowsingCreative> | null;
  campaigns: List<CreativePerformanceBrowsingCampaign> | null;
  ads: List<CreativePerformanceBrowsingAd> | null;
  placementTypes: AdAnalyticsPlacementTypes | null;
  onUpdatePlacementTypes: ({ platformKey, mediaKey, placementKey, period }: AdAnalyticsFilter) => void;
  onSubmitPlacementTypes: () => void;
  selectedPlacementTypes: AdAnalyticsFilter;
  selectedVideos: List<AdAnalyticsVideo>;
  filters: AdAnalyticsVideoFilter[];
  sort: AdAnalyticsVideoSort | null;
  hasMoreVideo: boolean;
  // onGotoAnalyticsPage: (idList: string[]) => void;
  // onGotoReportListPage: () => void;
  onSubmitFilters: (filters: AdAnalyticsVideoFilter[]) => void;
  onUpdateSort: (sort: AdAnalyticsVideoSort) => void;
  onClickLoadMoreVideoButton: () => void;
  onMount: () => void;
  onUnmount: () => void;
};

// const metricsType: { key: AdAnalyticsMetrics; label: string }[] = [
//   { key: 'impressions', label: 'adAnalytics_list.anlytics_list_item.detail.column_name.impression' },
//   { key: 'clicks', label: 'adAnalytics_list.anlytics_list_item.detail.column_name.click' },
//   { key: 'spend', label: 'adAnalytics_list.anlytics_list_item.detail.column_name.spend' },
//   { key: 'conversions', label: 'adAnalytics_list.anlytics_list_item.detail.column_name.cv' },
//   { key: 'view_through_conversions', label: 'adAnalytics_list.anlytics_list_item.detail.column_name.vtcv' },
//   { key: 'cvr', label: 'adAnalytics_list.anlytics_list_item.detail.column_name.cvr' },
//   { key: 'ctr', label: 'adAnalytics_list.anlytics_list_item.detail.column_name.ctr' },
//   { key: 'cpc', label: 'adAnalytics_list.anlytics_list_item.detail.column_name.cpc' },
//   { key: 'cpm', label: 'adAnalytics_list.anlytics_list_item.detail.column_name.cpm' },
//   { key: 'cpa', label: 'adAnalytics_list.anlytics_list_item.detail.column_name.cpa' },
//   { key: 'cpa_with_view_through_conversions', label: 'adAnalytics_list.anlytics_list_item.detail.column_name.cpavt' },
// ];

const ShowAdAnalyticsListPage: FC<Props> = ({
  loading,
  appendLoading,
  creatives,
  campaigns,
  ads,
  // placementTypes,
  // selectedPlacementTypes,
  // selectedVideos,
  // filters,
  sort,
  hasMoreVideo,
  // onUpdatePlacementTypes,
  // onSubmitPlacementTypes,
  className,
  // onSubmitFilters,
  onUpdateSort,
  onClickLoadMoreVideoButton,
  onMount,
  onUnmount,
}: {
  loading: boolean;
  appendLoading: boolean;
  creatives: List<CreativePerformanceBrowsingCreative> | null;
  campaigns: List<CreativePerformanceBrowsingCampaign> | null;
  ads: List<CreativePerformanceBrowsingAd> | null;
  placementTypes: AdAnalyticsPlacementTypes | null;
  selectedPlacementTypes: AdAnalyticsFilter;
  filters: AdAnalyticsVideoFilter[];
  sort: AdAnalyticsVideoSort | null;
  hasMoreVideo: boolean;
  className?: string;
  onUpdatePlacementTypes: ({ platformKey, mediaKey, placementKey, period }: AdAnalyticsFilter) => void;
  onSubmitPlacementTypes: () => void;
  onSubmitFilters: (filters: AdAnalyticsVideoFilter[]) => void;
  onUpdateSort: (sort: AdAnalyticsVideoSort) => void;
  onClickLoadMoreVideoButton: () => void;
  onMount: () => void;
  onUnmount: () => void;
}) => {
  useEffect(() => {
    onMount();
    return () => {
      onUnmount();
    };
    // TODO: Implementation before introducing rules
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const activePage = 'creative';
  const [activeTab, updateActiveTab] = useState<'creatives' | 'campaigns' | 'adsets' | 'ads'>('creatives');
  // const [inputFilters, updateInputFilters] = useState<AdAnalyticsVideoFilter[]>(filters);

  const handleChangeTab = (_: any, value: 'creatives' | 'campaigns' | 'adsets' | 'ads') => {
    updateActiveTab(value);
  };
  // const handleDeleteDetailFilter = (metrics: AdAnalyticsMetrics) => {
  //   const newFilters = inputFilters.filter((filter) => filter.metrics !== metrics);
  //   updateInputFilters(newFilters);
  //   onSubmitFilters(newFilters);
  // };

  // const submitPlacementTypeButton = (
  //   <Button color="primary" variant="contained" onClick={() => onSubmitPlacementTypes()}>
  //     <FormattedMessage id="adAnalytics_list.page_button_placements" />
  //   </Button>
  // );

  return (
    <Root className={className}>
      <Title variant="h5">
        <FormattedMessage id="adAnalytics_list.page_title" />
      </Title>

      <Tabs value={activePage} indicatorColor="primary" textColor="primary">
        <Tab label={<FormattedMessage id="adAnalytics_list.page_tab_creative" />} value="creative" />
      </Tabs>
      <Container>
        {loading ? (
          <Loading>
            <Spinner />
          </Loading>
        ) : (
          <>
            {creatives || campaigns || ads ? (
              <>
                <Tabs value={activeTab} onChange={handleChangeTab} indicatorColor="primary" textColor="primary">
                  <Tab label={<FormattedMessage id="adAnalytics_list.page_tab.creatives" />} value="creatives" />
                  <Tab label={<FormattedMessage id="adAnalytics_list.page_tab.campaigns" />} value="campaigns" />
                  <Tab label={<FormattedMessage id="adAnalytics_list.page_tab.ads" />} value="ads" />
                </Tabs>
                <AnalyticsItemTable
                  analyticsVideos={activeTab === 'creatives' ? creatives : activeTab === 'campaigns' ? campaigns : ads}
                  onUpdateSort={onUpdateSort}
                  sort={sort}
                />
                {hasMoreVideo && activeTab === 'creatives' && (
                  <LoadMore>
                    <LoadMoreButton
                      isLoading={appendLoading}
                      onClickLoadMore={() => {
                        onClickLoadMoreVideoButton();
                      }}
                    >
                      <FormattedMessage id="projects_list_page.load_more" />
                    </LoadMoreButton>
                  </LoadMore>
                )}
              </>
            ) : null}
          </>
        )}
      </Container>
    </Root>
  );
};

const Root = styled('section')({
  maxWidth: SCREEN_LARGE,
  margin: `0 auto ${SPACING_UNIT * 10}px`,
  paddingTop: `${SPACING_HUGE}px`,
});

const Container = styled(Paper)(
  gridLayoutContainer({
    columns: ['100%'],
    rows: ['auto'],
    areas: [['filter'], ['analytics']],
    alignItems: 'center',
  }),
  {
    width: 'auto',
    padding: SPACING_LARGE,
  },
);

const Title = styled(Typography)({
  marginBottom: SPACING_LARGE,
});

const Loading = styled('div')({
  padding: SPACING_HUGE,
});

// const MenuWrapper = styled('div')({
//   display: 'flex',
//   justifyContent: 'space-between',
//   marginBottom: SPACING_LARGE,
//   alignItems: 'start',
// });

const LoadMore = styled('div')({
  maxWidth: 320,
  margin: `${SPACING_HUGE}px auto 0`,
});

// const FilterListWrapper = styled('div')({
//   display: 'flex',
//   justifyContent: 'space-between',
// });

// const FilterList = styled('div')({
//   display: 'flex',
//   flexWrap: 'wrap',
//   width: '80%',
// });

// const FilterListItem = styled('div')({});

// const FilterListItemBody = styled('div')({
//   display: 'flex',
//   alignItems: 'center',
//   fontSize: '14px',
//   color: 'white',
//   backgroundColor: '#0070C9',
//   borderRadius: '8px',
//   padding: '4px 8px',
//   marginRight: '8px',
//   marginBottom: '8px',
//   minHeight: '24px',
// });

// const FilterListItemBadge = styled('span')({
//   display: 'flex',
//   position: 'absolute',
//   top: '-8px',
//   right: '0px',
//   fontSize: '12px',
//   borderRadius: '999px',
//   width: '20px',
//   height: '20px',
//   backgroundColor: 'gray',
//   color: '#ffffff',
//   flexDirection: 'column',
//   justifyContent: 'center',
//   textAlign: 'center',
//   cursor: 'pointer',
//   opacity: 0.9,
//   ':hover': {
//     opacity: 1,
//   },
// });

export default ShowAdAnalyticsListPage;
